<!--T1005776厦门国际银行-存款达标领取活动-分享-app分享到微信 -->
<template>
  <div>
    <div v-if="!isWeixn" @click="download" class="download-btn">
      如未安装手机银行，请<span style="text-decoration: underline"
        >点击下载</span
      >
    </div>
    <van-popup
      v-model:show="show"
      position="top"
      :close-on-click-overlay="false"
      class="open-browser-popup"
    >
      <img
        class="share-tip"
        :src="require(`@/assets/imgs/xiameBankDepositStandard/share-tip.png`)"
        alt=""
      />
    </van-popup>
    <div class="xiame-bank-deposit-standard-share" @click="toFastOpen">
      <img
        class="img"
        :src="require(`@/assets/imgs/xiameBankDepositStandard/pic.jpg`)"
        alt=""
      />
    </div>
  </div>
</template>
<script>
import { getActivityUrl } from './components/community'
export default {
  components: {},
  data() {
    return {
      title: '厦门国际银行',
      isWeixn: false, // 是否在微信环境
      show: false, // 提示浏览器打开弹窗
    }
  },
  async created() {
    this.isWeixn = this.isWeixnFun()
    this.toFastOpen()

  },
  mounted() {
  },
  methods: {
    close() {
      this.show = false
    },
    download() {
      console.log('download');
      if (this.isWeixn) return this.show = true
      window.loadAPPClick()
    },
    // 唤醒个人手机银行app
    toFastOpen() {
      console.log('唤醒个人手机银行app');

      if (this.isWeixn) return this.show = true
      // 跳转的app地址
      // let appPage = 'https://xib03.test.xib.com.cn:21443/ifspopenapi/thirdParty/auth/zcts?client_id=xib_ydsh&scope=m&xiblogin=true&xibshowtopbar=false&xibpopup=true'
      let appPage = getActivityUrl()

      //  当前分享页面
      let sharePage = window.location.href
      let openUrl = `xib://mobile.xib.com.cn?type=vue&url=${encodeURIComponent(appPage)}`
      let weUrl = `https://ifsp.xib.com.cn/ifspopenapi/thirdParty/auth/redirect?client_id=xib_ydsh&scope=m&xiblogin=true&redirect_uri=${encodeURIComponent(sharePage)}` //当前分享页面链接

      console.log(openUrl, weUrl);
      window.openApp(openUrl, weUrl, 'false')
    },
    isWeixnFun() {
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    },
  },
}
</script>
<style lang="less" scoped>
.download-btn {
  background: #fff;
  width: 100%;
  line-height: 2;
  text-align: center;
}

/deep/ .open-browser-popup {
  background: none;
  text-align: right;
  padding: 53px 28px 0 0;

  .share-tip {
    width: 265px;
  }
}

.xiame-bank-deposit-standard-share {
  .img {
    width: 100%;
    height: auto;
  }
}
</style>
